var app = angular.module("leonardo");

var WorkflowInstanceStopDialog = function($scope, AnalyticsService) {
  $scope.workflow = $scope.ngDialogData.workflow;
  $scope.submit = function() {
    $scope.workflow.stop().then(function() {
      AnalyticsService.track('Workflow Stopped', {
        ...AnalyticsService.getWorkflowGroupProperties($scope.workflow.workflow),
        property_id: $scope.workflow.property?.id,
        portfolio_id: $scope.workflow.property?.portfolio,
        account_id: $scope.workflow.account

      })
      $scope.confirm();
    });
  };
};

app.controller('WorkflowInstanceStopDialog', ['$scope', 'AnalyticsService', WorkflowInstanceStopDialog]);
